<app-header></app-header>
<div class="container px-5 min-h-100vh align-content-center">
    <div class="row m-0 align-content-center mt-4">
        <h1 class="ff-bold text-center">
            Anexo 24 Rubro C
        </h1>
        <small class="mt-4">
            <a class="text-decoration-none text-black pointer" routerLink="/">
            Anexo 24 Rubro C
            </a>
             
            <a *ngIf="categoryValue == 'Catálogos' " class="text-decoration-none text-black pointer" routerLink="/">
                >
                Catálogos
            </a>
            <a *ngIf="categoryValue == 'Módulo de Aduana' " class="text-decoration-none text-black pointer" routerLink="/">
                >
                Módulo de Aduana
            </a>
            <a *ngIf="categoryValue == 'Módulo de reports' " class="text-decoration-none text-black pointer" routerLink="/">
                >
                Módulo de reports
            </a>
             
            <a *ngIf="fetchTab == 'Datos' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >
                Datos generales del contribuyente  
            </a>

            <a *ngIf="fetchTab == 'Materiales' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >
                Materiales 
            </a>

            <a *ngIf="fetchTab == 'Productos' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >Productos  
            </a>

            <a *ngIf="fetchTab == 'Módulo de información aduanera de entradas' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >Módulo de información aduanera de entradas  
            </a>

            <a *ngIf="fetchTab == 'Módulo de información sobre materiales utilizados' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >Módulo de información sobre materiales utilizados  
            </a>

            <a *ngIf="fetchTab == 'Módulo de información aduanera de salidas' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >Módulo de información aduanera de salidas  
            </a>

            <a *ngIf="fetchTab == 'Módulo de activo fijo' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >Módulo de activo fijo  
            </a>

            <a *ngIf="fetchTab == 'Reporte de entrada de mercancías de importación temporal' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >Reporte de entrada de mercancías de importación temporal  
            </a>

            <a *ngIf="fetchTab == 'Reporte de salida de mercancías de importación temporal' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >Reporte de salida de mercancías de importación temporal  
            </a>

            <a *ngIf="fetchTab == 'Reporte de saldos de mercancías de importación temporal' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >Reporte de saldos de mercancías de importación temporal 
            </a>

            <a *ngIf="fetchTab == 'Reporte de materiales utilizados' " class="text-decoration-none text-black pointer" routerLink="/category/123">
                >Reporte de materiales utilizados  
            </a>

        </small>
        <h2 *ngIf="categoryValue == 'Catálogos' " class="ff-bold">
            Catálogos
        </h2>
        <h2 *ngIf="categoryValue == 'Módulo de Aduana' " class="ff-bold">
            Módulo de Aduana
        </h2>
        <h2 *ngIf="categoryValue == 'Módulo de reports' " class="ff-bold">
            Módulo de reports
        </h2>
    </div>

    <div *ngIf="categoryValue == 'Catálogos' " class="row m-0 category-block mt-4">
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <!--<label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Datos')">-->
                <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchDataDatosDetails()">   
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Datos generales del contribuyente
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Materiales')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Materiales
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Productos')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Productos
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
    </div>

    <div *ngIf="categoryValue == 'Módulo de Aduana' " class="row m-0 category-block mt-4">
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Módulo de información aduanera de entradas')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Módulo de información aduanera de entradas
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Módulo de información sobre materiales utilizados')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Módulo de información sobre materiales utilizados
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Módulo de información aduanera de salidas')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Módulo de información aduanera de salidas 
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Módulo de activo fijo')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Módulo de activo fijo 
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
    </div>

    <div *ngIf="categoryValue == 'Módulo de reports' " class="row m-0 category-block mt-4">
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Reporte de entrada de mercancías de importación temporal')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Reporte de entrada de mercancías de importación temporal
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Reporte de salida de mercancías de importación temporal')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Reporte de salida de mercancías de importación temporal
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Reporte de saldos de mercancías de importación temporal')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Reporte de saldos de mercancías de importación temporal
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" (click)="fetchFields('Reporte de materiales utilizados')">
                <a class="text-black ff-bold text-decoration-none py-3 py-md-5">
                    Reporte de materiales utilizados
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Datos' " class="row m-0 mt-4 search-block p-3">
        <!--<div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Datos.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Datos.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Número de IMMEX</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Datos.numeroImmex" name="numeroImmex" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Domicilio fiscal (Tax Address):</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Datos.domicilioFiscal" name="domicilioFiscal" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Extensiones de domicilio</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Datos.extensionesDomicilio" name="extensionesDomicilio" />
            </div>
        </div>-->
        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataDatosDetails()">
                Fetch Data
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Materiales' " class="row m-0 mt-4 search-block p-3">
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Materiales.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Materiales.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Fracción arancelaria</label>
                <div class="d-flex align-items-center">
                    <!-- Dropdown for condition with Bootstrap form-select class -->
                    <select class="form-select me-2" [(ngModel)]="formData.Materiales.arancelariaOperator" name="condition" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <!-- Input field for Fracción arancelaria -->
                    <input class="form-control" type="text" [(ngModel)]="formData.Materiales.arancelaria" name="numeroImmex" style="width: 50%;" />
                </div>
            </div>
        </div>               
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Descripción del material</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Materiales.descripcionOperator" name="conditionDescripcion" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Materiales.descripcion" name="domicilioFiscal" style="width: 50%;" />
                </div>
            </div>
        </div>
        
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Unidad de medida de la TIGIE</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Materiales.unidadOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Materiales.unidad" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>

        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Fecha</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Materiales.fechaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="equal">igual a</option>
                        <option value="greater">Más que</option>
                        <option value="less">Menos que</option>
                    </select>
                    <!-- Date input to ensure user selects a date in yyyy-mm-dd format -->
                    <input class="form-control" type="date" [min]="maxDate" [(ngModel)]="formData.Materiales.fecha" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>              

        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataMateriales()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Productos' " class="row m-0 mt-4 search-block p-3">
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Productos.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Productos.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Fracción arancelaria</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Productos.arancelariaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Productos.arancelaria" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Descripción del material</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Productos.descripcionOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Productos.descripcion" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Unidad de medida de la TIGIE</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Productos.unidadOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Productos.unidad" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Fecha</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Productos.fechaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="equal">igual a</option>
                        <option value="greater">Más que</option>
                        <option value="less">Menos que</option>
                    </select>
                    <input class="form-control" type="date" [min]="maxDate" [(ngModel)]="formData.Productos.fecha" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataProductos()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Módulo de información aduanera de entradas' " class="row m-0 mt-4 search-block p-3">
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Entradas.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Entradas.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Número de pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Entradas.numeroOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Entradas.numero" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Clave del pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Entradas.claveOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Entradas.clave" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Rango de Fecha</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Entradas.fechaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="equal">igual a</option>
                        <option value="greater">Más que</option>
                        <option value="less">Menos que</option>
                    </select>
                    <input class="form-control" type="date" [min]="maxDate" [(ngModel)]="formData.Entradas.fecha" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataEntradas()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Módulo de información sobre materiales utilizados' " class="row m-0 mt-4 search-block p-3">
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Utilizados.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Utilizados.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Número de parte</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Utilizados.numeroOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Utilizados.numero" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Descripción</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Utilizados.descripcionOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Utilizados.descripcion" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Unidad de comercialización</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Utilizados.unidadOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Utilizados.unidad" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Cantidad de mercancía</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Utilizados.cantidadOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="equal">igual a</option>
                        <option value="greater">Más que</option>
                        <option value="less">Menos que</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Utilizados.cantidad" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Rango de Fecha</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Utilizados.fechaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="equal">igual a</option>
                        <option value="greater">Más que</option>
                        <option value="less">Menos que</option>
                    </select>
                    <input class="form-control" type="date" [min]="maxDate" [(ngModel)]="formData.Utilizados.fecha" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataUtilizados()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Módulo de información aduanera de salidas' " class="row m-0 mt-4 search-block p-3">
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Salidas.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Salidas.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Número de pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Salidas.numeroOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Salidas.numero" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Clave del pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Salidas.claveOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Salidas.clave" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Rango de Fecha</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Salidas.fechaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="equal">igual a</option>
                        <option value="greater">Más que</option>
                        <option value="less">Menos que</option>
                    </select>
                    <input class="form-control" type="date" [min]="maxDate" [(ngModel)]="formData.Salidas.fecha" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataSalidas()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Módulo de activo fijo' " class="row m-0 mt-4 search-block p-3">
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Fijo.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Fijo.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Descripción de la mercancía</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Fijo.descripcionOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Fijo.descripcion" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Número de pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Fijo.numeroOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Fijo.numero" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Clave del pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Fijo.claveOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Fijo.clave" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Rango de Fecha</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Fijo.fechaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="equal">igual a</option>
                        <option value="greater">Más que</option>
                        <option value="less">Menos que</option>
                    </select>
                    <input class="form-control" type="date" [min]="maxDate" [(ngModel)]="formData.Fijo.fecha" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataFijo()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Reporte de entrada de mercancías de importación temporal' " class="row m-0 mt-4 search-block p-3">
       
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.TempEntrada.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.TempEntrada.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Número de pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.TempEntrada.numeroOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.TempEntrada.numero" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Clave del pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.TempEntrada.claveOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.TempEntrada.clave" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Rango de Fecha</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.TempEntrada.fechaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="equal">igual a</option>
                        <option value="greater">Más que</option>
                        <option value="less">Menos que</option>
                    </select>
                    <input class="form-control" type="date" [min]="maxDate" [(ngModel)]="formData.TempEntrada.fecha" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>

        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataTempEntrada()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Reporte de salida de mercancías de importación temporal' " class="row m-0 mt-4 search-block p-3">
        
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.TempSalida.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.TempSalida.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Número de pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.TempSalida.numeroOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.TempSalida.numero" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Clave del pedimento</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.TempSalida.claveOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.TempSalida.clave" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Rango de Fecha</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.TempSalida.fechaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="equal">igual a</option>
                        <option value="greater">Más que</option>
                        <option value="less">Menos que</option>
                    </select>
                    <input class="form-control" type="date" [min]="maxDate" [(ngModel)]="formData.TempSalida.fecha" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>

        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataTempSalida()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Reporte de saldos de mercancías de importación temporal' " class="row m-0 mt-4 search-block p-3">
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Saldos.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.Saldos.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Fracción arancelaria</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.Saldos.arancelariaOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.Saldos.arancelaria" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataSaldos()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="fetchTab == 'Reporte de materiales utilizados' " class="row m-0 mt-4 search-block p-3">
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Razón social</label>
                <input class="form-control" type="text" [(ngModel)]="formData.TempUtilizados.razonSocial" name="razonSocial" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">RFC (Tax ID)</label>
                <input class="form-control" type="text" [(ngModel)]="formData.TempUtilizados.rfc" name="rfc" />
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Número de parte</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.TempUtilizados.numeroOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.TempUtilizados.numero" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Descripción</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.TempUtilizados.descripcionOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.TempUtilizados.descripcion" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
                <label class="form-label">Unidad de comercialización</label>
                <div class="d-flex align-items-center">
                    <select class="form-select me-2" [(ngModel)]="formData.TempUtilizados.unidadOperator" name="conditionUnidad" style="width: 50%;">
                        <option value="" selected disabled>Select Operator</option>
                        <option value="contains">Contiene</option>
                        <option value="equal">igual a</option>
                    </select>
                    <input class="form-control" type="text" [(ngModel)]="formData.TempUtilizados.unidad" name="extensionesDomicilio" style="width: 50%;" />
                </div>
            </div>
        </div>
        
        <div class="col-12 col-md-4 px-2 py-0 mt-3">
            <div class="form-group">
              <label class="form-label">Rango de Fecha</label>
              <div class="d-flex align-items-center">
                <select class="form-select me-2" [(ngModel)]="formData.TempUtilizados.fechaOperator" name="conditionUnidad" style="width: 50%;">
                  <option value="" selected disabled>Select Operator</option>
                  <option value="equal">igual a</option>
                  <option value="greater">Más que</option>
                  <option value="less">Menos que</option>
                </select>
                <input 
                  class="form-control" 
                  type="date" 
                  [(ngModel)]="formData.TempUtilizados.fecha" 
                  name="extensionesDomicilio" 
                  style="width: 50%;" 
                  [min]="maxDate"
                />
              </div>
            </div>
          </div>
          
                   
        <div class="col-12 p-0 mt-4">
            <button class="btn btn-dark px-5" type="button" (click)="fetchDataTempUtilizados()">
                Search
            </button>
            <button class="btn btn-light px-5 ms-4" type="button" routerLink="/">
                Back
            </button>
        </div>
    </div>

    <div *ngIf="tableView" class="row m-0 mt-4 search-block p-3">
        <div class="col-12 col-md-4 px-2 py-0 w-100 table-container">
            
            <table class="table table-bordered border-dark">
                <thead>
                    <tr>
                        <ng-container *ngFor="let key of headerKeys">
                            <th *ngIf="key !== 'location'" class="text-nowrap p-2 border border-dark" (click)="sortData(key)">
                                {{ capitalizeHeader(key) }}
                            </th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="data.length === 0">
                        <td [attr.colspan]="headerKeys.length - 1" class="text-center">No records found</td> <!-- Adjust colspan if 'Location' is excluded -->
                    </tr>
                    <tr *ngFor="let item of data">
                        <ng-container *ngFor="let key of headerKeys">
                            <td *ngIf="key !== 'location'">
                                {{ item[key] }}
                            </td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>            
    
            <!-- Pagination Controls -->
            <div class="pagination-container">
                <button class="pagination-btn" (click)="changePage(1)" [disabled]="currentPage === 1">
                    <i class="fas fa-angle-double-left"></i> First
                </button>
                <button class="pagination-btn" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
                    <i class="fas fa-angle-left"></i> Prev
                </button>
                <span class="pagination-info">Page {{ currentPage }} of {{ totalPages }}</span>
                <button class="pagination-btn" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
                    Next <i class="fas fa-angle-right"></i>
                </button>
                <button class="pagination-btn" (click)="changePage(totalPages)" [disabled]="currentPage === totalPages">
                    Last <i class="fas fa-angle-double-right"></i>
                </button>
            </div>
    
            <aside class="total-records">
                <p>Total Records: {{ totalRecords }} | Filtered Records: {{ filteredRecords }}</p>
            </aside>
        </div>
    </div>
</div>
<app-footer></app-footer>